import { render } from "./CartDetailItem.vue?vue&type=template&id=dbcd5980"
import script from "./CartDetailItem.vue?vue&type=script&lang=js"
export * from "./CartDetailItem.vue?vue&type=script&lang=js"
script.render = render

export default script